import { useSelector } from 'react-redux';
import { useMetric } from '@modules/FilterTypes/metric';

import { getSelectedMetric } from '../selectors';

export const useSelectedMetric = () => {
  const [, setMetric] = useMetric();
  return [useSelector(getSelectedMetric), setMetric];
};
